/* eslint-disable react/jsx-wrap-multilines */
import React, { useState, useContext, useEffect } from "react";
import * as _ from "underscore";
import SlidingPane from "react-sliding-pane";
import statusPrettier from "shared/statusprettier";
import { AppContext } from "components/AppContext";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faCaretUp, faCaretDown } from "@fortawesome/free-solid-svg-icons";
import formatTime from "./FormatTime";
import { ExtractReportContext } from "../ExtractReportContext";
import ActionsKebab from "./ActionsKebab";
import "react-sliding-pane/dist/react-sliding-pane.css";
import columns from "./ColumnData";
import "moment-timezone";
import DataTable from "components/DataTable";
import {
  Button,
  Card,
  CardBody,
  Collapse,
  Input,
  InputGroup,
} from "reactstrap";
import FilterIcon from "components/Images/FilterIcon";
import DownArrow from "components/Images/DownArrow";
import MultiSelector from "./MultiSelector";
import { SingleDatePicker } from "react-dates";
import ClearIcon from "components/Images/clearIcon";
import moment from "moment";
import { ModalDialog } from "shared/Modal";

export const constrctFilterToken = ({
  selectedOption,
  selectedScheduleOptions,
  searchTerm,
  startDate,
  endDate
}) => {
  const reportLastStatus = selectedOption?.map(item => item.value);
  const reportScheduleStatus = selectedScheduleOptions?.value;
  const payload = {};

  if (reportLastStatus?.length !== 0) {
    payload.reportlaststatus = { in: reportLastStatus };
  }

  if (searchTerm?.length >= 0) {
    payload.reporttitle = {
      ilk: searchTerm
    };
  }

  if (reportScheduleStatus?.length !== 0) {
    payload.reportschedule = { nl: reportScheduleStatus };
  }

  if (startDate && endDate) {
    payload.reportlastrunon = {
      gte: startDate,
      lte: endDate
    };
  }
  return btoa(
    JSON.stringify([
      {
        and: [payload]
      }
    ])
  );
};

const ReportTable = () => {
  const {
    reports,
    selectedFilters,
    getReportHistory,
    slideData,
    modalState,
    setModalState,
    setRunReportStatus,
    downloadReport,
    setFilterConfig,
    resetReportsGrid,
    setSlideData,
    setPaginationToken,
    newToken,
    currentPaginationProps,
    setCurrentPaginationProps,
    setClearFilters,
    deleteModalState,
    setDeleteModalState,
    DeleteReport
  } = useContext(ExtractReportContext);
  const { timezone } = useContext(AppContext);

  // const [filtersOpen, setFiltersOpen] = useState(false);
  const [tableData, setTableData] = useState([]);
  const data = [];
  const [deleteReportData, setDdeleteReportData] = useState({
    accountid: undefined,
    dagid: undefined,
    reportid: undefined
  });

  const handleActionsKebab = (button, accountid, dagid, reportid) => {
    if (button === "Report Details") {
      getReportHistory(accountid, dagid, reportid);
    }
    if (button === "Delete Report") {
      setDeleteModalState(true);
      setDdeleteReportData({ accountid, dagid, reportid });
    }
  };

  const closeModal = () => {
    setModalState({ isPaneOpen: false });
    setRunReportStatus("");
    setSlideData();
  };

  const setData = shownReports => {
    shownReports.forEach((report, index) => {
      data.push({
        id: `${index}${report.reportid}`,
        keyField: report.reportid,
        extractName: report.reporttitle,
        description: report.reportdescription,
        lastRunStatus: `${statusPrettier(report.reportlaststatus)}`,
        nextRunTime: formatTime(report.reportnextrunon, timezone),
        lastRunTime: formatTime(report.reportlastrunon, timezone),
        actions: (
          <ActionsKebab
            failed={report.reportlaststatus === "ERROR" && true}
            success={report.reportlaststatus === "SUCCESS" && true}
            inprogress={report.reportlaststatus === "INPROGRESS" && true}
            queued={report.reportlaststatus === "QUEUED" && true}
            na={
              (report.reportlaststatus === "NA" ||
                report.reportlaststatus === null) &&
              true
            }
            handleReturn={handleActionsKebab}
            accountid={report.accountid}
            dagid={report.dagid}
            reportid={report.reportid}
            editLink={`/app/account/${report.accountid}/dags/${report.dagid}/reports/${report.reportid}`}
            downloadAction={downloadReport}
            executionId={report.execution}
          />
        )
      });
    });

    if (shownReports.length === data.length) {
      setTableData(data);
    }
  };

  useEffect(() => {
    if (reports) {
      setData(reports);
    }

    if (slideData) {
      setModalState({ isPaneOpen: true });
      setRunReportStatus("");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reports, selectedFilters, slideData]);

  useEffect(() => {
    const persistedFilters = window.localStorage.getItem("REPORT_FILTERS");
    const parsedFilters = JSON.parse(persistedFilters);
    if (parsedFilters) {
      const parsedFilters = JSON.parse(persistedFilters);

      if (parsedFilters?.lastRunStatus?.length > 0) {
        setSelectedOption(parsedFilters.lastRunStatus);
      }
      if (parsedFilters?.scheduleStatus) {
        setSelectedScheduleOptions(parsedFilters.scheduleStatus);
      }
      if (parsedFilters?.searchTerm) {
        setSearchTerm(parsedFilters.searchTerm);
      }
      if (parsedFilters?.startDate) {
        const date = moment(parsedFilters.startDate);
        setStartDate(date);
      }
      if (parsedFilters?.endDate) {
        const date = moment(parsedFilters.endDate);
        setEndDate(date);
      }

      setToggle(true);
    }
  }, []);

  const settings = {
    expanded: "",
    sortBy: [
      {
        id: "sortname",
        desc: false
      }
    ],
    globalFilter: "",
    hiddenColumns: ["id"]
  };

  const [toggle, setToggle] = useState(false);
  const [startDatePickerFocus, setStartDatePickerFocus] = useState(false);
  const [endDatePickerFocus, setEndDatePickerFocus] = useState(false);
  const [invalidScheduleMessage, setInvalidScheduleMessage] = useState("");
  const [startDate, setStartDate] = useState(null); // moment date obj
  const [endDate, setEndDate] = useState(null); // moment date obj
  const [searchTerm, setSearchTerm] = useState(undefined);
  const [selectedOption, setSelectedOption] = useState([]);
  const [selectedScheduleOptions, setSelectedScheduleOptions] = useState([]);
  const options = [
    { value: "SUCCESS", label: "Completed" },
    { value: "ERROR", label: "Failed" },
    { value: "NA", label: "Draft" },
    { value: "QUEUED", label: "Queued" },
    { value: "INPROGRESS", label: "In Progress" }
  ];

  const scheduleOptions = [
    { value: false, label: "Scheduled" },
    { value: true, label: "Not Scheduled" }
  ];

  const handleSatrtDateChange = date => {
    setInvalidScheduleMessage("");
    if (date === null) {
      setInvalidScheduleMessage(
        `Please choose a date between today and
         {maxDate.format(
          "MM/DD/YYYY"
        )
      }.`
      );
    } else {
      setStartDate(date);
    }
  };

  const handleEndDateChange = date => {
    setInvalidScheduleMessage("");
    if (date === null) {
      setInvalidScheduleMessage(
        `Please choose a date between today and
         {maxDate.format(
          "MM/DD/YYYY"
        )
      }.`
      );
    } else {
      setEndDate(date);
    }
  };
  const handleClear = () => {
    setSearchTerm(undefined);
    setStartDate(null);
    setEndDate(null);
    setSelectedOption([]);
    setSelectedScheduleOptions([]);
    resetReportsGrid();
    setFilterConfig(null);
    clearFilters();
    setClearFilters(true);
  };

  const persistFilters = filters => {
    window.localStorage.setItem("REPORT_FILTERS", JSON.stringify(filters));
  };

  const clearFilters = () => {
    window.localStorage.setItem("REPORT_FILTERS", null);
  };

  const handleFilter = () => {
    resetReportsGrid();

    const filters = {
      lastRunStatus: selectedOption,
      scheduleStatus: selectedScheduleOptions,
      searchTerm,
      startDate,
      endDate
    };
    persistFilters(filters);
    const filtertoken = constrctFilterToken({
      selectedOption,
      selectedScheduleOptions,
      searchTerm,
      startDate,
      endDate
    });
    setFilterConfig(filtertoken);
  };

  const getMoreReports = ({ pageIndex, gotoPage }) => {
    setCurrentPaginationProps({ pageIndex, gotoPage });
    setPaginationToken(newToken);
  };

  return (
    <div>
      <div style={{ marginLeft: 32 }}>
        <span
          onClick={() => setToggle(!toggle)}
          style={{
            cursor: "pointer",
            marginBottom: "1rem",
            display: "flex",
            width: "20% "
          }}
        >
          <FilterIcon />
          <span style={{ color: "#0B78D0", margin: "0px 5px" }}>Filters</span>
          <span style={toggle ? { transform: "rotate(180deg)" } : undefined}>
            <DownArrow />
          </span>
        </span>
        <Collapse isOpen={toggle}>
          <Card style={{ border: "none" }}>
            <CardBody>
              <div>Filter by:</div>
              <InputGroup size="small" style={{ width: "30%", marginTop: 5 }}>
                <Input
                  value={searchTerm || ""}
                  onChange={e => {
                    setSearchTerm(e.target.value);
                  }}
                  size="small"
                  placeholder="Search by Report Name"
                />

                {searchTerm?.length >= 0 && (
                  <Button
                    style={{
                      color: "#0B78D0",
                      backgroundColor: "#FFF",
                      border: "1px solid #ced4da"
                    }}
                    className="btn-primary"
                    onClick={() => setSearchTerm(undefined)}
                  >
                    <ClearIcon />
                  </Button>
                )}
              </InputGroup>
              <div
                style={{
                  display: "grid",
                  gridGap: 20,
                  gridTemplateColumns: "repeat(8, 1fr)",
                  marginTop: 32
                }}
              >
                <MultiSelector
                  placeholder="Last Run Status"
                  selectedOption={selectedOption}
                  onChange={setSelectedOption}
                  isMulti
                  options={options}
                  closeMenuOnSelect={false}
                />
                <MultiSelector
                  placeholder="Last Run Schedule"
                  selectedOption={selectedScheduleOptions}
                  onChange={setSelectedScheduleOptions}
                  isMulti={false}
                  options={scheduleOptions}
                  closeMenuOnSelect={false}
                />

                <SingleDatePicker
                  id="start-date"
                  date={startDate}
                  onDateChange={handleSatrtDateChange}
                  focused={startDatePickerFocus}
                  onFocusChange={() =>
                    setStartDatePickerFocus(!startDatePickerFocus)
                  }
                  required
                  numberOfMonths={1}
                  openDirection="down"
                  placeholder="Start Date"
                  maxDate={endDate ? endDate : undefined}
                  isOutsideRange={day => day.isAfter(endDate)}
                />
                <SingleDatePicker
                  isOutsideRange={day => day.isBefore(startDate)}
                  placeholder="End Date"
                  required
                  numberOfMonths={1}
                  onDateChange={handleEndDateChange}
                  openDirection="down"
                  minDate={startDate ? startDate : undefined}
                  focused={endDatePickerFocus}
                  onFocusChange={() =>
                    setEndDatePickerFocus(!endDatePickerFocus)
                  }
                  date={endDate}
                  id="endDate"
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: 32,
                  marginRight: 20
                }}
              >
                <Button
                  color={"primary"}
                  disabled={
                    (searchTerm?.length === undefined &&
                      startDate === null &&
                      endDate === null &&
                      selectedOption?.length === 0 &&
                      selectedScheduleOptions?.length === 0) ||
                    (endDate === null && startDate !== null) ||
                    (endDate !== null && startDate === null)
                  }
                  style={{
                    marginRight: 12
                  }}
                  onClick={handleFilter}
                >
                  Apply
                </Button>
                <Button color={"secondary"} outline onClick={handleClear}>
                  Clear All
                </Button>
              </div>
            </CardBody>
          </Card>
        </Collapse>
      </div>
      <section>
        <DataTable
          columns={columns}
          data={tableData}
          options={settings}
          onLastPage={getMoreReports}
        />
      </section>
      {slideData && (
        <SlidingPane
          style={{ zIndex: 2 }}
          shouldCloseOnEsc
          isOpen={modalState.isPaneOpen}
          title={slideData.title}
          subtitle={slideData.subtitle}
          onRequestClose={() => closeModal()}
          closeIcon={
            <svg
              width="30"
              height="26"
              viewBox="0 0 30 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              tabIndex="0"
              onKeyPress={() => closeModal()}
            >
              <path
                d="M29.3171 2.61857L26.3832 0L14.7513 10.3814L3.11951 0L0.185547 2.61857L11.8174 13L0.185547 23.3814L3.11951 26L14.7513 15.6186L26.3832 26L29.3171 23.3814L17.6853 13L29.3171 2.61857Z"
                fill="#595959"
              />
            </svg>
          }
        >
          {slideData.content}
        </SlidingPane>
      )}
      {deleteModalState && (
        <ModalDialog
          open={deleteModalState}
          message="This will permanently delete the extract, are you sure you wish to continue?"
          handleCancel={() => {
            setDeleteModalState(false);
          }}
          handleGotIt={() => DeleteReport(deleteReportData)}
        />
      )}
    </div>
  );
};

export default ReportTable;
